const Picker = {
    settings: {
        bundle_max: Number(window.productPickerConfig.productAmount)
    },
    Defaults: {
        getAddToCartButton: function () {
            return $('.bundle-builder__add')
        },
        bundle: function () {
            return $('.bottle-selector')
        }
    },
    Utils: {
        calculateBundleQuantity: function () {
            let bundle_qty = 0
            Picker.Defaults.bundle().find('.bundle-builder-item').each(function () {
                bundle_qty += Number($(this).attr('data-qty'))
            })
            return bundle_qty
        },
        calculatePrice: function () {
            let total = 0
            Picker.Defaults.bundle().find('.bundle-builder-item').each(function () {
                const qty = Number($(this).attr('data-qty'))
                const price = Number($(this).attr('data-item-price'))
                total += (price * qty)
            })

            const num = total / 100
            return (Math.round(num * 100) / 100).toFixed(2)
        },
        handleDecrease: function ($item) {
            const new_bundle_qty = Picker.Utils.calculateBundleQuantity() - 1
            const new_item_qty = Number($item.attr('data-qty')) - 1

            if (new_item_qty >= 0) {
                Picker.Utils.updatePickerItem($item, new_item_qty, new_bundle_qty)
            }
        },
        handleIncrease: function ($item) {
            const new_bundle_qty = Picker.Utils.calculateBundleQuantity() + 1
            const new_item_qty = Number($item.attr('data-qty')) + 1

            if (Picker.Constraints.isBundleLessThanMax(new_bundle_qty)) {
                Picker.Utils.updatePickerItem($item, new_item_qty, new_bundle_qty)
            }
        },
        updatePickerItem: function ($item, new_item_qty, new_bundle_qty) {
            $item.attr('data-qty', new_item_qty)
            $item.find('.bundle-builder__display-qty').html(new_item_qty)

            if (new_item_qty > 0) {
                $item.find('.decrease').removeClass('inactive')
            } else {
                $item.find('.decrease').addClass('inactive')
            }

            Picker.Utils.updateQtyButtons()
            Picker.Utils.updateAddButton()
        },
        updateQtyButtons: function () {
            const $bundle = Picker.Defaults.bundle()
            const bundle_max = Picker.settings.bundle_max
            const bundle_qty = Picker.Utils.calculateBundleQuantity()

            let is_disabled = false

            $bundle.find('.bundle-builder-item').each(function () {
                const item_qty = Number($(this).attr('data-qty'))
                is_disabled = bundle_qty >= bundle_max
                $(this).find('.increase').toggleClass('inactive', is_disabled)
                // Toggle minus button
                is_disabled = item_qty === 0
                $(this).find('.decrease').toggleClass('inactive', is_disabled)
            })
        },
        updateAddButton: function () {
            const bundle_qty = Picker.Utils.calculateBundleQuantity()
            const bundle_max = Picker.settings.bundle_max

            const $button = Picker.Defaults.getAddToCartButton()
            const $text = $button.find('span')

            const price = Picker.Utils.calculatePrice()

            if (bundle_qty < bundle_max) {
                $button.attr('disabled', 'disabled')
                $text.text(`Select ${bundle_max - bundle_qty} products`)
            } else {
                $button.removeAttr('disabled')
                $text.text(`checkout - $${price}`)
            }
        }
    },
    Constraints: {
        isBundleLessThanMax: function (new_qty) {
            if (new_qty > Picker.settings.bundle_max) {
                console.log("Quantity cannot be greater than maximum.")
                return false
            }
            return true
        },
    },
    Cart: {
        processAddToCart: function () {
            const $bundle = Picker.Defaults.bundle()
            const items = Picker.Cart.generateCart($bundle)

            const combinedItems = Object.values(items.reduce((accumulator, currentValue) => {
                  const { id, quantity } = currentValue
                  accumulator[id] = accumulator[id] || { id, quantity: 0 }
                  accumulator[id].quantity += quantity
                  return accumulator
              }, {}),
            )

            if (combinedItems.length > 0) {
                Picker.Cart.processToCart(combinedItems);
                // console.log(combinedItems)
            } else {
                console.log("No items available to add to cart.");
            }
        },
        generateCart: function ($bundle) {
            let cart = []

            $bundle.find('.bundle-builder-item').each(function () {
                const qty = Number($(this).attr('data-qty'))
                if (qty > 0) {
                    const variant_id = $(this).attr('data-variant-id')
                    const item = {
                        id: variant_id,
                        quantity: qty
                    }
                    cart.push(item)
                }
            })

            // Gets gifts
            $('.bundle-builder__gift.checked').each(function () {
                const variant_id = $(this).attr('data-id')
                const item = {
                    id: variant_id,
                    quantity: 1
                }
                cart.push(item)
            })

            //FREEBIE
            $('.dropdown__filter-selected').each(function () {
                const variant_id = $(this).attr('data-item-id')
                const item = {
                    id: variant_id,
                    quantity: 1
                }
                cart.push(item)
            })

            return cart
        },
        processToCart: function (items) {
            let data = {}
            items.forEach((item) => {
                data[item.id] = item.quantity
            })

            const host = 'https://beautybyearth.com/cart/'
            const itemUrl = Object.keys(data).map((key) => key + ':' + data[key]).join(',')
            // const discount = '?discount=shipfn'
            const discount = '?discount=BOGO-ELT01'

            // console.log(host + itemUrl + discount)

            // window.location.href = host + itemUrl
            window.location.href = host + itemUrl + discount
        }
    },
    init: function () {
        $("body").on('click', '.bundle-builder__container .decrease', function () {
            const $item = $(this).closest('.bundle-builder-item')
            Picker.Utils.handleDecrease($item)
        })

        $("body").on('click', '.bundle-builder__container .increase', function () {
            const $item = $(this).closest('.bundle-builder-item')
            Picker.Utils.handleIncrease($item)
        })

        $("body").on('click', '.bundle-builder__add', function () {
            event.preventDefault()
            $(this).addClass('loading')
            $(this).attr('disabled', 'disabled')
            Picker.Cart.processAddToCart()
        })
    }
}
Picker.init()